export const TEST_IDS = {
  AI_UNSAVED_CHANGES_MODAL_TEST_ID: 'ai-unsaved-changes-modal',
  AI_UNSAVED_CHANGES_MODAL_SAVE_BUTTON: 'ai-unsaved-changes-modal-save-button',
};

export const MODAL_HEADER_TEXT = 'Unsaved Changes';
export const getModalBodyText = (resourceName: string) =>
  `This ${resourceName} has been edited. Do you want to save your changes?`;
export const MODAL_FOOTER_TEXT = 'Leave without saving';
